"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const codeMirrorUtils_1 = require("./codeMirrorUtils");
function useUpdateCodeMirrorTags({ choiceGroups, codeMirrorRef, onClickTag, }) {
    react_1.useLayoutEffect(() => {
        if (codeMirrorRef.current) {
            codeMirrorUtils_1.updateCodeMirrorTags({
                choiceGroups,
                codeMirror: codeMirrorRef.current,
                onClickTag,
            });
        }
    }, [codeMirrorRef, onClickTag, choiceGroups]);
}
exports.default = useUpdateCodeMirrorTags;
